import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  SelectChangeEvent,
  SxProps,
  Theme,
} from "@mui/material";
import { ITransactionTypeModel } from "../types/types";

interface TransactionTypeFilterSelectProps {
  transactionTypes: ITransactionTypeModel[];
  selectedTransactionTypeIds: number[];
  onChange: (transactionTypeIds: number[]) => void;
  label?: string;
  fullWidth?: boolean;
  size?: "small" | "medium";
  sx?: SxProps<Theme>;
}

export const TransactionTypeFilterSelect: React.FC<
  TransactionTypeFilterSelectProps
> = ({
  transactionTypes,
  selectedTransactionTypeIds,
  onChange,
  label = "Transaction Types",
  fullWidth = true,
  size = "small",
  sx,
}) => {
  const handleChange = (e: SelectChangeEvent<number[]>) => {
    const value = e.target.value as number[];
    onChange(value);
  };

  return (
    <FormControl fullWidth={fullWidth} size={size} sx={sx}>
      <InputLabel shrink={true}>{label}</InputLabel>
      <Select
        multiple
        notched={true}
        value={selectedTransactionTypeIds}
        displayEmpty
        onChange={handleChange}
        label={label}
        renderValue={(selected) => {
          if (selected.length === 0) {
            return "All Types";
          }

          if (selected.length > 3) {
            return `${selected.length} types selected`;
          }

          return selected
            .map((id) => transactionTypes.find((t) => t.id === id)?.name)
            .join(", ");
        }}
        MenuProps={{
          sx: { zIndex: 1500 },
          PaperProps: {
            style: {
              maxHeight: 300,
            },
          },
        }}
      >
        {transactionTypes.map((type) => (
          <MenuItem key={type.id} value={type.id}>
            <Checkbox
              checked={
                type.id !== undefined &&
                selectedTransactionTypeIds.indexOf(type.id) > -1
              }
            />
            <ListItemText primary={type.name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
